var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenerateUniqueId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28.453,
    height: 33.664,
    viewBox: "0 0 28.453 33.664",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17276",
    "data-name": "Rectangle 17276",
    width: 28.453,
    height: 33.664,
    fill: "none",
    stroke: "#3873ae",
    strokeWidth: 3
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1871",
    "data-name": "Group 1871",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7529",
    "data-name": "Path 7529",
    d: "M6.64,5.121a11.67,11.67,0,0,0,6.348,21.463",
    transform: "translate(0.528 2.052)",
    fill: "none",
    stroke: "#3873ae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7530",
    "data-name": "Path 7530",
    d: "M7.663,25.118l3.731-3.731L7.671,17.666",
    transform: "translate(3.07 7.077)",
    fill: "none",
    stroke: "#3873ae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7531",
    "data-name": "Path 7531",
    d: "M17.013,25.053A11.67,11.67,0,0,0,10.665,3.59",
    transform: "translate(4.272 1.438)",
    fill: "none",
    stroke: "#3873ae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7532",
    "data-name": "Path 7532",
    d: "M13.72,1.048,9.988,4.779,13.711,8.5",
    transform: "translate(4.001 0.42)",
    fill: "none",
    stroke: "#3873ae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateUniqueId);
export default __webpack_public_path__ + "static/media/generate-unique-id.b054eef1a8d4bf713a7cb49599a3ca93.svg";
export { ForwardRef as ReactComponent };